/* sevitec 3D-Startseite – Wandaufbau beim Scrollen und Wandrechner in echter Größe (three.js r128, wird erst nach dem Laden der Seite nachgeladen) */
(() => {
const sec = document.getElementById("s3d");
if (!sec || sec.dataset.init) return;
sec.dataset.init = "1";
// ---------- Wandrechner (#wandrechner): Rechenweg wie im Shop-Wandrechner, Preise und Varianten live aus Shopify
const LIVE = (() => { try { return JSON.parse(document.getElementById("s3d-preise").textContent); } catch (e) { return {}; } })();
const artikel = (handle, name, preis, id) => ({ name, handle: "/products/" + handle,
  preis: LIVE[handle] && LIVE[handle].preis ? LIVE[handle].preis / 100 : preis, variantId: LIVE[handle] && LIVE[handle].id ? LIVE[handle].id : id });
const SHOP = {
  element: { breite: 0.6, hoehe: 0.98 },
  typen: {
    vp54: { name: "VP54", gewicht: 28.12, dicke: .054, co2: 5.37 * 44 / 12, el: artikel("vp54-blockelement", "VP54 Blockelement", 39, 57737448128860), leiste: artikel("holzleiste-vp54", "Holzleiste VP54", 3, 57797268701532) },
    vp70: { name: "VP70", gewicht: 34.2, dicke: .07, co2: 7.9 * 44 / 12, el: artikel("vp70-blockelement", "VP70 Blockelement", 45, 57739472568668), leiste: artikel("holzleiste-vp70", "Holzleiste VP70", 3, 57812372324700) },
    hv84: { name: "HV84", gewicht: 24.3, dicke: .084, co2: 12.17 * 44 / 12, el: artikel("hv84", "HV84 Blockelement", 48, 57769562112348), leiste: artikel("holzleiste-hv84", "Holzleiste HV84", 4, 57812373242204) },
    sp54: { name: "SP54", gewicht: 23.82, dicke: .054, co2: 9.82 * 44 / 12, el: artikel("sp54-blockelement", "SP54 Blockelement", 36, 58260465746268), leiste: artikel("holzleiste-vp54", "Holzleiste VP54", 3, 57797268701532) },
  },
  leisteLaenge: 1,
  halbeFeder: Object.assign(artikel("halbe-holzfeder-kiefer", "Halbe Feder (1 m)", 1, 58305262616924), { laenge: 1 }),
  feder: Object.assign(artikel("verbindungsfeder-spanplatte", "Verbindungsfeder", 1, 57812369178972), { proElement: 1.6 }),
  kleber: Object.assign(artikel("faayfix-montagekleber", "FAAYFIX Montagekleber", 12, 57812374782300), { m2ProKartusche: 3 }),
  farbe: Object.assign(artikel("wandfarbe-weiss-5-l", "Wandfarbe Weiß 5 L", 40, 57923887432028), { m2ProGebinde: 17 }),
  faayfoam: artikel("faayfoam-montageschaum", "FAAYFOAM Montageschaum", 20, 58935914922332),
  gipsstreifen: { laenge: 1, vp54: artikel("gipsstreifen", "Gipsstreifen für VP54 (1 m)", 4, 58349990379868), vp70: artikel("gipsstreifen-fur-vp70", "Gipsstreifen für VP70 (1 m)", 4, 58386381013340) },
  reserveAbElementen: 8, minutenProM2: 12,
};
function berechne(laenge, hoehe, typ, opt) {
  const t = SHOP.typen[typ], flaeche = laenge * hoehe;
  const elemente = Math.ceil(flaeche / (SHOP.element.breite * SHOP.element.hoehe));
  const reserve = opt.reserve === null || opt.reserve === undefined ? elemente >= SHOP.reserveAbElementen : opt.reserve;
  const p = (a, qty, name) => ({ name: name || a.name, qty, preis: a.preis, variantId: a.variantId, handle: a.handle });
  const posten = [p(t.el, elemente)];
  if (reserve) posten.push(p(t.el, 1, `${t.name} Reserve-Element (Verschnitt)`));
  posten.push(p(t.leiste, Math.ceil(laenge * 2 / SHOP.leisteLaenge)), p(SHOP.halbeFeder, Math.ceil(hoehe * 2 / SHOP.halbeFeder.laenge)),
    p(SHOP.feder, Math.ceil(elemente * SHOP.feder.proElement)), p(SHOP.kleber, Math.ceil(flaeche / SHOP.kleber.m2ProKartusche)));
  if (opt.farbe) posten.push(p(SHOP.farbe, Math.ceil(flaeche * 2 / SHOP.farbe.m2ProGebinde)));
  if (opt.foam) posten.push(p(SHOP.faayfoam, 1));
  if (opt.ecke) { const n = Math.ceil((opt.eckeHoehe || 0) / SHOP.gipsstreifen.laenge); if (n > 0) posten.push(p(SHOP.gipsstreifen[opt.gipsTyp] || SHOP.gipsstreifen.vp70, n)); }
  const summe = posten.reduce((a, x) => a + x.qty * x.preis, 0);
  return { flaeche, elemente, reserve, posten, summe, gewicht: Math.round(flaeche * t.gewicht), co2: flaeche * t.co2, minuten: flaeche * SHOP.minutenProM2 };
}
const eur = (n) => n.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
const zahl = (n, d = 0) => n.toLocaleString("de-DE", { minimumFractionDigits: d, maximumFractionDigits: d });
const dauer = (min) => { const g = Math.max(5, Math.round(min / 5) * 5), h = Math.floor(g / 60), m = g % 60; return h ? `${h} h${m ? ` ${m} min` : ""}` : `${m} min`; };
const $ = (id) => document.getElementById(id);
const still = matchMedia("(prefers-reduced-motion: reduce)").matches;

const ein = { laenge: $("r-laenge"), hoehe: $("r-hoehe"), nLaenge: $("n-laenge"), nHoehe: $("n-hoehe"), reserve: $("o-reserve"), farbe: $("o-farbe"),
  foam: $("o-foam"), ecke: $("o-ecke"), eckeHoehe: $("ecke-hoehe"), gipsTyp: $("gips-typ") };
let reserveManuell = false, letzte = null;
const zaehlen = (el, ziel, fmt) => {           // Zahlen weich hochzählen
  const von = +(el.dataset.wert || 0); el.dataset.wert = ziel;
  if (still) { el.textContent = fmt(ziel); return; }
  const t0 = performance.now();
  const schritt = (t) => { const k = Math.min(1, (t - t0) / 700), e = 1 - Math.pow(1 - k, 3); el.textContent = fmt(von + (ziel - von) * e); if (k < 1) requestAnimationFrame(schritt); };
  requestAnimationFrame(schritt);
};
function rechnen() {
  const L = Math.min(20, Math.max(.6, +ein.laenge.value || .6)), H = Math.min(4, Math.max(.98, +ein.hoehe.value || .98));
  const typ = sec.querySelector('input[name="s3d-typ"]:checked').value;
  if (document.activeElement !== ein.nLaenge) ein.nLaenge.value = L.toFixed(2);
  if (document.activeElement !== ein.nHoehe) ein.nHoehe.value = H.toFixed(2);
  $("ecke-wrap").hidden = !ein.ecke.checked;
  const r = berechne(L, H, typ, { reserve: reserveManuell ? ein.reserve.checked : null, farbe: ein.farbe.checked, foam: ein.foam.checked,
    ecke: ein.ecke.checked, eckeHoehe: +ein.eckeHoehe.value, gipsTyp: ein.gipsTyp.value });
  if (!reserveManuell) ein.reserve.checked = r.reserve;
  zaehlen($("k-flaeche"), r.flaeche, (v) => `${zahl(v, 1)} m²`);
  zaehlen($("k-elemente"), r.elemente, (v) => zahl(v));
  zaehlen($("k-co2"), r.co2, (v) => `${zahl(v)} kg`);
  zaehlen($("k-gewicht"), r.gewicht, (v) => `${zahl(v)} kg`);
  zaehlen($("k-preis"), r.summe, (v) => `${zahl(v)} €`);
  $("k-zeit").textContent = dauer(r.minuten);
  $("liste").innerHTML = r.posten.map((p) => `<div><span><a href="${p.handle}">${p.name}</a> <span class="menge">× ${p.qty}</span></span><span class="betrag">${eur(p.qty * p.preis)}</span></div>`).join("");
  $("summe").textContent = eur(r.summe);
  letzte = { L, H, typ, r };
  if (window.__wand) window.__wand.rechnerWand(L, H, typ, r);
}
const koppeln = (regler, feld) => {
  regler.addEventListener("input", () => { feld.value = (+regler.value).toFixed(2); rechnen(); });
  feld.addEventListener("input", () => { const v = parseFloat(String(feld.value).replace(",", ".")); if (v >= +regler.min && v <= +regler.max) { regler.value = v; rechnen(); } });
  feld.addEventListener("change", () => { regler.value = Math.min(+regler.max, Math.max(+regler.min, parseFloat(String(feld.value).replace(",", ".")) || +regler.min)); feld.value = (+regler.value).toFixed(2); rechnen(); });
};
koppeln(ein.laenge, ein.nLaenge); koppeln(ein.hoehe, ein.nHoehe);
[ein.farbe, ein.foam, ein.ecke, ein.eckeHoehe, ein.gipsTyp].forEach((e) => e.addEventListener("input", rechnen));
ein.gipsTyp.addEventListener("change", rechnen);
ein.reserve.addEventListener("change", () => { reserveManuell = true; rechnen(); });
sec.querySelectorAll('input[name="s3d-typ"]').forEach((r) => r.addEventListener("change", () => { if (SHOP.gipsstreifen[r.value]) ein.gipsTyp.value = r.value; rechnen(); }));

// Alles in den Warenkorb – gleiche Artikel und Mengen wie in der Liste
$("s3d-warenkorb").addEventListener("click", () => {
  if (!letzte) return;
  const knopf = $("s3d-warenkorb"), status = $("s3d-status"), mengen = {};
  letzte.r.posten.forEach((p) => { mengen[p.variantId] = (mengen[p.variantId] || 0) + p.qty; });
  knopf.disabled = true; status.textContent = "Wird in den Warenkorb gelegt …";
  fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ items: Object.keys(mengen).map((id) => ({ id: +id, quantity: mengen[id] })) }) })
    .then((res) => res.ok ? res.json() : res.json().then((e) => { throw new Error(e.description || "Fehler beim Hinzufügen"); }))
    .then(() => { status.textContent = "Erledigt – deine Materialliste liegt im Warenkorb."; location.href = "/cart"; })
    .catch((err) => { status.textContent = "Das hat leider nicht geklappt: " + err.message; knopf.disabled = false; });
});

// ---------- Ansicht wechseln: Startseite <-> Wandrechner (#wandrechner)
const titel0 = document.title, hero = sec.querySelector(".s3d__hero"), start = $("s3d-start"), seite = $("rechner-seite");
function route() {
  const r = location.hash === "#wandrechner", neu = r ? "rechner" : "start";
  if (neu === sec.dataset.modus) return;
  const vorher = sec.dataset.modus; sec.dataset.modus = neu;
  hero.hidden = r; start.hidden = r; seite.hidden = !r;
  document.title = r ? "Wandrechner – " + titel0 : titel0;
  if (r) { laden(); window.scrollTo({ top: 0, behavior: "instant" }); rechnen(); }
  else if (vorher) window.scrollTo({ top: 0, behavior: "instant" });
  if (window.__wand) window.__wand.modus(neu);
}
window.__rechnen = rechnen;

// Beispielzahlen im Wandrechner-Teaser (3,00 × 2,50 m, VP70)
const bsp = berechne(3, 2.5, "vp70", { reserve: null });
const setz = (id, v) => { const el = document.getElementById(id); if (el) el.textContent = v; };
setz("tz-el", bsp.elemente); setz("tz-co2", `${zahl(bsp.co2)} kg`); setz("tz-zeit", `${zahl(bsp.minuten / 60, 1)} h`);

// three.js erst laden, wenn jemand scrollt/tippt oder kurz nach dem Seitenaufbau (schont die Ladezeit des Headbilds)
let geladen = false;
function laden() {
  if (geladen) return; geladen = true;
  if (window.THREE) return szene();
  const s = document.createElement("script"); s.src = sec.dataset.three; s.async = true;
  s.onload = szene; s.onerror = () => sec.classList.add("ohne3d");
  document.head.appendChild(s);
}
["scroll", "wheel", "pointerdown", "touchstart", "keydown"].forEach((ev) => addEventListener(ev, laden, { once: true, passive: true }));
const spaeter = () => setTimeout(laden, 1800);
if (document.readyState === "complete") spaeter(); else addEventListener("load", spaeter);
addEventListener("hashchange", route);
route();

function szene() {
  if (!window.THREE) { sec.classList.add("ohne3d"); return; }
  const T = THREE;
  const canvas = sec.querySelector(".s3d__buehne canvas");
  let renderer;
  try { renderer = new T.WebGLRenderer({ canvas, antialias: true }); } catch (e) { sec.classList.add("ohne3d"); return; }
  const mobilStart = innerWidth < 900;
  renderer.setPixelRatio(Math.min(devicePixelRatio, mobilStart ? 1.75 : 2));
  renderer.outputEncoding = T.sRGBEncoding;
  renderer.toneMapping = T.ACESFilmicToneMapping; renderer.toneMappingExposure = 1.05;
  renderer.shadowMap.enabled = true; renderer.shadowMap.type = T.PCFSoftShadowMap;
  const still = matchMedia("(prefers-reduced-motion: reduce)").matches;

  const scene = new T.Scene();
  const HG = new T.Color("#e3e7dc");
  scene.background = HG; scene.fog = new T.Fog(HG, 14, 34);
  const camera = new T.PerspectiveCamera(36, 1, .05, 80);

  // ---------- Texturen
  const aniso = renderer.capabilities.getMaxAnisotropy();
  function tex(w, h, malen, wdh) {
    const c = document.createElement("canvas"); c.width = w; c.height = h; malen(c.getContext("2d"), w, h);
    const t = new T.CanvasTexture(c); t.encoding = T.sRGBEncoding; t.anisotropy = aniso;
    if (wdh) { t.wrapS = t.wrapT = T.RepeatWrapping; t.repeat.set(wdh[0], wdh[1]); }
    return t;
  }
  const rnd = (a, b) => a + Math.random() * (b - a);
  function koernung(g, w, h, basis, n, s) {
    g.fillStyle = basis; g.fillRect(0, 0, w, h);
    for (let i = 0; i < n; i++) { g.fillStyle = Math.random() > .5 ? `rgba(255,255,255,${rnd(0, s)})` : `rgba(0,0,0,${rnd(0, s)})`; g.fillRect(rnd(0, w), rnd(0, h), rnd(.6, 2.2), rnd(.6, 2.2)); }
  }
  function blattPfad(g, x, y, s, farbe) {         // Blatt-Logo
    g.save(); g.translate(x, y); g.scale(s / 24, s / 24); g.fillStyle = farbe;
    g.fill(new Path2D("M20 3C10 3 4 8 4 15c0 2 .6 3.7 1.6 5l1.5-1.5C9 14 12 11 16 9c-3 2.6-5.6 6-7.4 10.4 1 .4 2.1.6 3.4.6 7 0 9-7.5 8-17z")); g.restore();
  }
  function gips(g, w, h) { koernung(g, w, h, "#dcd7cb", w * h / 18, .05); }
  const gipsTex = tex(512, 512, gips);
  function gipsDruck(hoehenAnteil) {             // bedruckte Vorderseite: Blatt + "Flachskern · biobasiert" wie ein Herstelleraufdruck
    return tex(512, Math.round(512 * hoehenAnteil * .995 / .6), (g, w, h) => {
      gips(g, w, h);
      const y = h * (hoehenAnteil < .7 ? .34 : .18), ink = "rgba(59,106,31,.82)";
      blattPfad(g, w * .5 - 34, y - 70, 68, ink);
      g.fillStyle = ink; g.textAlign = "center";
      g.font = "700 30px 'Barlow Semi Condensed', Arial, sans-serif"; g.fillText("FLACHSKERN · BIOBASIERT", w / 2, y + 26);
      g.font = "600 21px 'Source Sans 3', Arial, sans-serif"; g.fillText("sevitec · CO₂ gespeichert im Flachs", w / 2, y + 56);
      g.strokeStyle = "rgba(59,106,31,.35)"; g.lineWidth = 2; g.strokeRect(w * .5 - 190, y - 82, 380, 158);
    });
  }
  function flachs(g, w, h) {
    g.fillStyle = "#c7a066"; g.fillRect(0, 0, w, h);
    const f = ["#a98249", "#dcbb86", "#b8925a", "#e6cb98", "#8f6c3c"];
    for (let i = 0; i < w * h / 55; i++) { g.strokeStyle = f[i % 5]; g.globalAlpha = rnd(.25, .7); g.lineWidth = rnd(.6, 1.6);
      const x = rnd(0, w), y = rnd(0, h), a = rnd(0, Math.PI), l = rnd(4, 18); g.beginPath(); g.moveTo(x, y); g.lineTo(x + Math.cos(a) * l, y + Math.sin(a) * l); g.stroke(); }
    g.globalAlpha = 1;
  }
  const kernFlaeche = tex(512, 512, flachs);
  const kernOben = tex(1024, 96, (g, w, h) => { flachs(g, w, h); g.fillStyle = "rgba(70,50,25,.55)"; g.fillRect(0, h * .34, w, h * .32);
    for (const x of [w * .3, w * .7]) { g.fillStyle = "#3b2d19"; g.beginPath(); g.ellipse(x, h / 2, h * .36, h * .36, 0, 0, Math.PI * 2); g.fill(); } });
  const kernSeite = tex(96, 1024, (g, w, h) => { flachs(g, w, h); g.fillStyle = "rgba(70,50,25,.55)"; g.fillRect(w * .34, 0, w * .32, h); });
  const holzTex = tex(512, 64, (g, w, h) => { g.fillStyle = "#cf9a5f"; g.fillRect(0, 0, w, h);
    for (let i = 0; i < 46; i++) { g.strokeStyle = `rgba(120,70,25,${rnd(.08, .3)})`; g.lineWidth = rnd(.5, 2); g.beginPath(); const y = rnd(0, h);
      g.moveTo(0, y); g.bezierCurveTo(w * .3, y + rnd(-4, 4), w * .6, y + rnd(-4, 4), w, y + rnd(-3, 3)); g.stroke(); } });
  const bodenTex = tex(512, 512, (g, w, h) => {      // heller Estrich mit feinem Planraster (Kachel = 1 m)
    koernung(g, w, h, "#cdc8bb", 26000, .05);
    g.strokeStyle = "rgba(61,107,33,.16)"; g.lineWidth = 2; g.strokeRect(1, 1, w - 2, h - 2);
    g.strokeStyle = "rgba(61,107,33,.07)"; g.lineWidth = 1; g.beginPath(); g.moveTo(w / 2, 0); g.lineTo(w / 2, h); g.moveTo(0, h / 2); g.lineTo(w, h / 2); g.stroke();
  }, [60, 60]);
  // ---------- Materialien
  const M = {
    gips: new T.MeshStandardMaterial({ map: gipsTex, roughness: .92 }),
    gipsKante: new T.MeshStandardMaterial({ color: "#d3cec2", roughness: .9 }),
    kern: new T.MeshStandardMaterial({ map: kernFlaeche, roughness: 1 }),
    kernOben: new T.MeshStandardMaterial({ map: kernOben, roughness: 1 }),
    kernSeite: new T.MeshStandardMaterial({ map: kernSeite, roughness: 1 }),
    holz: new T.MeshStandardMaterial({ map: holzTex, roughness: .7 }),
    farbe: new T.MeshStandardMaterial({ color: "#f8f7f2", roughness: .95, transparent: true, opacity: 0 }),
    dunkel: new T.MeshStandardMaterial({ color: "#151714", roughness: .35, metalness: .2 }),
    gruen: new T.MeshStandardMaterial({ color: "#3b6a1f", roughness: .8 }),
    blatt1: new T.MeshStandardMaterial({ color: "#4f8a2b", roughness: .7, side: T.DoubleSide }),
    blatt2: new T.MeshStandardMaterial({ color: "#6fa83a", roughness: .7, side: T.DoubleSide }),
    topf: new T.MeshStandardMaterial({ color: "#d8d3c6", roughness: .9 }),
    ton: new T.MeshStandardMaterial({ color: "#b8754a", roughness: .85 }),
    raum: new T.MeshStandardMaterial({ color: "#efeee8", roughness: .95 }),
    rahmen: new T.MeshStandardMaterial({ color: "#2f3a2b", roughness: .6, metalness: .1 }),
    stroh: new T.MeshStandardMaterial({ color: "#c9a764", roughness: .8 }),
  };

  // ---------- Licht
  scene.add(new T.HemisphereLight("#ffffff", "#a9a291", .62));
  const sonne = new T.DirectionalLight("#fff1dc", 1.45);         // Sonne schräg von vorn rechts
  sonne.position.set(5.5, 7, 6.5); sonne.target.position.set(1.6, .8, .5); sonne.castShadow = true;
  const sm = mobilStart ? 1024 : 2048; sonne.shadow.mapSize.set(sm, sm);
  Object.assign(sonne.shadow.camera, { left: -9, right: 9, top: 10, bottom: -6, near: 1, far: 34 }); sonne.shadow.bias = -.0005; sonne.shadow.radius = 3;
  scene.add(sonne, sonne.target);
  const front = new T.DirectionalLight("#eef4ff", .35); front.position.set(-5, 3, 4); front.target.position.set(1, 1, 0); scene.add(front, front.target);
  const studio = new T.DirectionalLight("#fff4e2", 1.2); studio.position.set(4.5, 7, 6); studio.castShadow = true; studio.visible = false;
  studio.shadow.mapSize.set(sm, sm); Object.assign(studio.shadow.camera, { left: -9, right: 9, top: 8, bottom: -3, near: 1, far: 30 }); studio.shadow.bias = -.0004;
  studio.target.position.set(4, 1, 0); scene.add(studio, studio.target);

  function box(w, h, d, mat) { const m = new T.Mesh(new T.BoxGeometry(w, h, d), mat); m.castShadow = m.receiveShadow = true; return m; }

  // ---------- Boden (für beide Ansichten)
  const boden = new T.Mesh(new T.PlaneGeometry(60, 60), new T.MeshStandardMaterial({ map: bodenTex, roughness: .95 }));
  boden.rotation.x = -Math.PI / 2; boden.receiveShadow = true; scene.add(boden);

  // ---------- Freie Bühne (Startseite): heller Hintergrund und eine Bestandswand, an die die neue Trennwand angeschlossen wird
  const raum = new T.Group(); scene.add(raum);
  scene.background = tex(16, 512, (g, w, h) => { const v = g.createLinearGradient(0, 0, 0, h); v.addColorStop(0, "#f1f3ec"); v.addColorStop(.62, "#e3e7dc"); v.addColorStop(1, "#d6dbcf"); g.fillStyle = v; g.fillRect(0, 0, w, h); });
  scene.fog = new T.Fog("#dfe3d8", 13, 32);
  const bestand = box(.175, 2.8, 2.6, new T.MeshStandardMaterial({ color: "#b9b4a8", roughness: .95 }));   // Bestandswand (verputzt), dunkler als die neuen Elemente
  bestand.position.set(-.0875, 1.4, -.7); raum.add(bestand);

  // ---------- Trennwand: 4 Spalten (2,40 m), Aufbau wie auf der Baustelle
  const B = .6, H = .995, GK = .0095, KD = .07 - 2 * GK, LH = .03, FUGE = .003, SP = 4;
  function block(hoehe) {
    const g = new T.Group();
    const kern = box(B - FUGE, hoehe - FUGE, KD, [M.kernSeite, M.kernSeite, M.kernOben, M.kernOben, M.kern, M.kern]);
    const vorne = box(B - FUGE, hoehe - FUGE, GK, [M.gipsKante, M.gipsKante, M.gipsKante, M.gipsKante, M.gips, M.gips]);
    const hinten = box(B - FUGE, hoehe - FUGE, GK, [M.gipsKante, M.gipsKante, M.gipsKante, M.gipsKante, M.gips, M.gips]);
    vorne.position.z = KD / 2 + GK / 2; hinten.position.z = -(KD / 2 + GK / 2);
    g.add(kern, vorne, hinten); g.userData = { kern, vorne, hinten };
    return g;
  }
  const startGruppe = new T.Group(); scene.add(startGruppe);
  const wand = new T.Group(); startGruppe.add(wand);
  const M_leiste = new T.MeshStandardMaterial({ map: holzTex, color: "#d2a271", roughness: .65 });
  const oben = LH + 2.5 * H, WH = oben - LH;
  const leisteU = box(SP * B, LH, .07, M_leiste); leisteU.geometry.translate(SP * B / 2, 0, 0); leisteU.position.set(0, LH / 2, 0); wand.add(leisteU);
  const wandFeder = box(.016, WH, .029, M_leiste); wandFeder.position.set(.008, LH + WH / 2, 0); wand.add(wandFeder);     // lange Feder an der Bestandswand
  const spalten = [[1, 1, .5], [.5, 1, 1], [1, 1, .5], [.5, 1, 1]];     // versetzte Fugen; halbe Elemente werden vor Ort zugeschnitten
  const teile = [];
  spalten.forEach((sp, s) => { let unten = LH; sp.forEach((f, r) => {
    const hoehe = f * H, g = block(hoehe), ziel = new T.Vector3(s * B + B / 2, unten + hoehe / 2, 0); g.position.copy(ziel); wand.add(g);
    let feder = null; if (r > 0) { feder = box(B - .06, .028, .016, M_leiste); feder.position.set(ziel.x, unten + .006, 0); wand.add(feder); }   // kurze Feder in der waagerechten Fuge
    let vfeder = null; if (s > 0) { vfeder = box(.028, hoehe - .06, .016, M_leiste); vfeder.position.set(s * B, ziel.y, 0); wand.add(vfeder); }   // kurze Feder (max. 1 m) in der senkrechten Fuge
    teile.push({ g, ziel, hoehe, feder, vfeder, s, r, halb: f < 1 }); unten += hoehe; }); });
  const leisteO = box(SP * B, LH, .07, M_leiste); leisteO.geometry.translate(SP * B / 2, 0, 0); leisteO.position.set(0, oben + LH / 2, 0); wand.add(leisteO);
  const anstrich = new T.Mesh(new T.PlaneGeometry(SP * B + .004, WH + .002), M.farbe); anstrich.position.set(SP * B / 2, LH + WH / 2, .0352); wand.add(anstrich);
  const anstrichH = anstrich.clone(); anstrichH.rotation.y = Math.PI; anstrichH.position.z = -.0352; wand.add(anstrichH);
  const deko = new T.Group(); wand.add(deko);
  const tv = box(1.05, .6, .035, M.dunkel); tv.position.set(1.2, 1.62, .06); deko.add(tv);
  const regal = box(1.3, .03, .24, M.holz); regal.position.set(1.2, .98, .155); deko.add(regal);
  [[.7, .2], [.75, .17], [.8, .22]].forEach(([x, h]) => { const b = box(.04, h, .17, M.gruen); b.position.set(x, .995 + h / 2, .15); deko.add(b); });
  const topf2 = new T.Mesh(new T.CylinderGeometry(.06, .05, .12, 24), M.ton); topf2.position.set(1.65, 1.055, .15); topf2.castShadow = true; deko.add(topf2);
  for (let i = 0; i < 9; i++) { const b = new T.Mesh(new T.SphereGeometry(.05, 10, 6), i % 2 ? M.blatt1 : M.blatt2); b.scale.set(1, .25, .6);
    b.position.set(1.65 + Math.cos(i) * .05, 1.16 + (i % 3) * .03, .15 + Math.sin(i) * .05); b.rotation.set(rnd(-.6, .6), i, rnd(-.6, .6)); b.castShadow = true; deko.add(b); }
  deko.traverse((o) => { if (o.material) { o.material = o.material.clone(); o.material.transparent = true; } });

  // Palette: nur ganze Elemente. Zuschnitt auf zwei Böcken: aus einem ganzen Element werden zwei Hälften.
  const PAL = new T.Vector3(4.3, 0, 1.7), BOCK = new T.Vector3(2.75, 0, 2.35), BOCKH = .5;
  const palette = new T.Group(); startGruppe.add(palette); palette.position.copy(PAL);
  for (const x of [-.5, 0, .5]) { const k = box(.1, .1, 1.1, M.holz); k.position.set(x, .05, 0); palette.add(k); }
  for (let i = 0; i < 7; i++) { const b = box(1.25, .022, .1, M.holz); b.position.set(0, .111, -.5 + i / 6); palette.add(b); }
  const boecke = new T.Group(); startGruppe.add(boecke); boecke.position.copy(BOCK);
  for (const x of [-.3, .3]) {                       // zwei schlanke Arbeitsböcke
    const balken = box(.045, .045, .72, M.holz); balken.position.set(x, BOCKH - .0225, 0); boecke.add(balken);
    for (const dz of [-.28, .28]) for (const sx of [-1, 1]) {
      const bein = box(.03, BOCKH + .02, .03, M.holz); bein.position.set(x + sx * .06, BOCKH / 2 - .02, dz); bein.rotation.z = -sx * .2; boecke.add(bein); }
  }
  const schnittLinie = new T.Mesh(new T.BoxGeometry(.006, .08, .62), new T.MeshBasicMaterial({ color: "#ff7a2f" }));
  schnittLinie.visible = false; startGruppe.add(schnittLinie);
  const qWand = new T.Quaternion();
  const qFlach = (e) => new T.Quaternion().setFromEuler(new T.Euler(-Math.PI / 2, 0, Math.PI / 2 + (e % 2 ? .012 : -.012)));
  const stapelPos = (nr, gesamt) => new T.Vector3(PAL.x, .157 + (gesamt - 1 - nr) * .071, PAL.z);   // zuerst gebrauchtes Element liegt oben

  // Ablauf: Leiste unten -> lange halbe Feder an der Bestandswand -> Leiste oben -> Elemente Spalte für Spalte, jedes mit seinen kurzen Federn
  const schritte = [{ art: "leisteU" }, { art: "wandfeder" }, { art: "leisteO" }];
  let stapel = 0, offen = null, schnitte = 0;
  spalten.forEach((sp, s) => {
    teile.filter((p) => p.s === s).forEach((p) => {
      if (!p.halb) { p.quelle = "stapel"; p.nr = stapel++; }
      else if (offen) { p.quelle = "rest"; p.schnitt = offen; p.seite = -1; offen = null; }
      else { const sch = { nr: stapel++, id: schnitte++ }; schritte.push({ art: "schnitt", sch }); p.quelle = "rest"; p.schnitt = sch; p.seite = 1; offen = sch; }
      const st = { art: "block", p }; schritte.push(st); p.schritt = st;
    });
  });
  const VOLLE = stapel;
  const T0 = .015, T1 = .485, DT = (T1 - T0) / schritte.length;
  schritte.forEach((st, k) => { st.zeit = [T0 + k * DT, T0 + (k + 1.15) * DT]; if (st.art === "schnitt") st.sch.zeit = st.zeit; });
  const zeitVon = (art) => schritte.find((s) => s.art === art).zeit;
  teile.forEach((p) => { if (p.quelle === "stapel") { p.start = stapelPos(p.nr, VOLLE); p.qStart = qFlach(p.nr); } });

  const CO2_BLOCK = .6 * .995 * 7.9 * 44 / 12;   // VP70 laut EPD, je ganzem Element

  // ---------- Sägestaub beim Zuschnitt
  const staubMat = new T.MeshBasicMaterial({ color: "#d8c8a6", transparent: true, depthWrite: false, side: T.DoubleSide });
  const partikel = [];
  function staub(pos) {
    if (still) return;
    for (let i = 0; i < 24; i++) {
      const m = new T.Mesh(new T.PlaneGeometry(.018, .018), staubMat.clone()); m.position.copy(pos).add(new T.Vector3(rnd(-.03, .03), 0, rnd(-.3, .3)));
      m.userData = { v: new T.Vector3(rnd(-.45, .45), rnd(.15, .6), rnd(-.2, .2)), r: new T.Vector3(rnd(-4, 4), rnd(-4, 4), 0), t: 0, d: rnd(.7, 1.2) };
      scene.add(m); partikel.push(m);
    }
  }

  // ---------- Rechner-Wand (Unterseite): Wand in echter Größe mit Maßketten
  const rechnerGruppe = new T.Group(); rechnerGruppe.visible = false; scene.add(rechnerGruppe);
  const linienMat = new T.LineBasicMaterial({ color: "#3b6a1f" });
  let rechnerWand = null, aufbau = null;
  function linie(punkte) { const g = new T.BufferGeometry().setFromPoints(punkte); return new T.Line(g, linienMat); }
  const rechnerBlaetter = [];
  window.__wandBau = (L, Hh, typ) => {
    if (rechnerWand) { rechnerWand.traverse((o) => { if (o.geometry && o.geometry !== undefined) o.geometry.dispose(); }); rechnerGruppe.remove(rechnerWand); }
    rechnerWand = new T.Group(); rechnerGruppe.add(rechnerWand);
    const d = SHOP.typen[typ].dicke, EH = SHOP.element.hoehe, n = Math.ceil(L / B - 1e-6);
    const stuecke = [];
    for (let s = 0; s < n; s++) {
      const w = Math.min(B, L - s * B); let y = LH, r = 0;
      const muster = s % 2 ? [.5] : [];                     // versetzte Fugen: jede zweite Spalte beginnt mit halbem Element
      while (y < LH + Hh - 1e-3) { const hh = Math.min((muster[r] ?? 1) * EH, LH + Hh - y); stuecke.push({ x: s * B + w / 2, y: y + hh / 2, w, h: hh, s, r }); y += hh; r++; }
    }
    stuecke.sort((a, b) => a.s - b.s || a.r - b.r);   // Spalte für Spalte, von unten nach oben
    const kd = d - 2 * GK;
    stuecke.forEach((p, i) => {
      const g = new T.Group();
      const kern = box(p.w - FUGE, p.h - FUGE, kd, [M.kernSeite, M.kernSeite, M.kernOben, M.kernOben, M.kern, M.kern]);
      const vorne = box(p.w - FUGE, p.h - FUGE, GK, [M.gipsKante, M.gipsKante, M.gipsKante, M.gipsKante, M.gips, M.gips]);
      const hinten = vorne.clone(); hinten.material = M.gips;
      vorne.position.z = kd / 2 + GK / 2; hinten.position.z = -(kd / 2 + GK / 2); g.add(kern, vorne, hinten);
      g.position.set(p.x, p.y, 0); g.userData = { y: p.y, i }; g.visible = false; rechnerWand.add(g);
    });
    const lu = box(L, LH, d, M.holz); lu.position.set(L / 2, LH / 2, 0); rechnerWand.add(lu);
    const lo = box(L, LH, d, M.holz); lo.position.set(L / 2, LH + Hh + LH / 2, 0); rechnerWand.add(lo);
    // Maßketten
    const z = d / 2 + .25, gesamtH = Hh + 2 * LH;
    rechnerWand.add(linie([new T.Vector3(0, .02, z), new T.Vector3(L, .02, z)]), linie([new T.Vector3(0, .02, z - .08), new T.Vector3(0, .02, z + .08)]), linie([new T.Vector3(L, .02, z - .08), new T.Vector3(L, .02, z + .08)]));
    rechnerWand.add(linie([new T.Vector3(L + .25, 0, d / 2), new T.Vector3(L + .25, gesamtH, d / 2)]), linie([new T.Vector3(L + .17, 0, d / 2), new T.Vector3(L + .33, 0, d / 2)]), linie([new T.Vector3(L + .17, gesamtH, d / 2), new T.Vector3(L + .33, gesamtH, d / 2)]));
    rechnerWand.userData = { L, H: gesamtH, z, n: stuecke.length };
    aufbau = { t0: performance.now(), dauer: still ? 1 : Math.min(2600, 500 + stuecke.length * 45), n: stuecke.length };
    document.getElementById("k-zeit-box").classList.add("bauen");
    schmutzig = true;
  };

  // ---------- Zeitplan Startseite
  const Z = { leisteU: [.015, .05], erst: .055, abstand: .03, flug: .055, leisteO: [.45, .485], auf: [.53, .59], zu: [.68, .72], farbe: [.72, .77], deko: [.86, .92] };
  const KAM = [   // freie Bühne: Kamera immer rechts der Bestandswand
    [0, [6.4, 2.4, 7.6], [2.6, .95, .8]],
    [.12, [6.9, 2.1, 6.4], [2.3, 1.0, .6]],
    [.26, [1.9, 2.4, 8.0], [1.4, 1.2, 0]],
    [.38, [4.9, 2.7, 7.6], [1.4, 1.25, 0]],
    [.48, [6.8, 2.3, 5.6], [1.4, 1.25, 0]],
    [.55, [4.4, 2.15, 5.2], [1.2, 1.15, .5]],
    [.63, [2.9, 2.0, 4.3], [1.1, 1.1, .8]],
    [.71, [4.7, 1.85, 6.6], [1.3, 1.25, 0]],
    [.8, [1.7, 1.65, 7.9], [1.25, 1.25, -.2]],
    [.9, [6.0, 1.8, 7.0], [1.4, 1.3, -.3]],
    [1, [3.6, 2.0, 9.8], [1.8, 1.2, -.6]],
  ];
  const kurveP = new T.CatmullRomCurve3(KAM.map((k) => new T.Vector3(...k[1])), false, "centripetal");
  const kurveZ = new T.CatmullRomCurve3(KAM.map((k) => new T.Vector3(...k[2])), false, "centripetal");
  function kurvenU(t) { for (let i = 1; i < KAM.length; i++) if (t <= KAM[i][0]) { const a = KAM[i - 1][0], b = KAM[i][0]; return (i - 1 + (t - a) / (b - a)) / (KAM.length - 1); } return 1; }
  const clamp = (v) => Math.max(0, Math.min(1, v));
  const anteil = (t, [a, b]) => clamp((t - a) / (b - a));
  const ease = (x) => 1 - Math.pow(1 - x, 3);
  const glatt = (x) => x * x * (3 - 2 * x);

  const marken = { gips: document.getElementById("m-gips"), kern: document.getElementById("m-kern"), kanal: document.getElementById("m-kanal") };
  const zEl = document.getElementById("z-el"), zCo2 = document.getElementById("z-co2");
  const auf = teile.find((p) => p.s === 1 && p.r === 1);   // ganzes Element in der 2. Spalte wird aufgeklappt
  const tmp = new T.Vector3(), zielP = new T.Vector3(), zielZ = new T.Vector3();
  let tVorher = 0;

  const tmpP = new T.Vector3();
  function teilLage(p, t) {                 // Lage eines Teils: vom Stapel (ganz) oder von den Böcken (zugeschnittene Hälfte) in die Wand
    const [a, b] = p.schritt.zeit, x = clamp((t - a) / (b - a)), k = still ? x : glatt(x);
    let von, qVon;
    if (p.quelle === "stapel") { von = p.start.clone(); qVon = p.qStart; }
    else {
      const sch = p.schnitt, c = clamp((t - sch.zeit[0]) / (sch.zeit[1] - sch.zeit[0]));
      const hin = still ? clamp(c / .5) : glatt(clamp(c / .5)), trennen = glatt(clamp((c - .86) / .14));
      const ab = stapelPos(sch.nr, VOLLE).add(new T.Vector3(p.seite * H / 4, 0, 0));
      const bock = new T.Vector3(BOCK.x + p.seite * (H / 4 + .04 * trennen), BOCKH + .035, BOCK.z);
      von = ab.lerp(bock, hin); von.y += Math.sin(Math.PI * hin) * (still ? 0 : .55);
      qVon = qFlach(sch.nr);
    }
    const kh = Math.min(1, k / .8);         // erst auf Höhe bringen, dann von vorn unter die obere Leiste einschieben
    tmpP.lerpVectors(von, p.ziel, kh); tmpP.z = von.z + (p.ziel.z - von.z) * k; tmpP.y += Math.sin(Math.PI * kh) * (still ? 0 : .9);
    p.g.position.copy(tmpP);
    p.g.quaternion.copy(qVon).slerp(qWand, still ? k : ease(Math.min(1, k * 1.25)));
    return x;
  }

  function startSzene(t) {
    leisteU.scale.x = Math.max(.001, ease(anteil(t, zeitVon("leisteU"))));
    const wf = ease(anteil(t, zeitVon("wandfeder"))); wandFeder.visible = wf > 0; wandFeder.position.y = LH + WH / 2 + (1 - wf) * 1.3;
    let schnittAktiv = false;
    for (const st of schritte) {
      if (st.art === "schnitt") {
        const c = anteil(t, st.zeit);
        if (c > .5 && c < .86) {
          schnittAktiv = true; const s = (c - .5) / .36;
          schnittLinie.position.set(BOCK.x, BOCKH + .036, BOCK.z - .31 + s * .31); schnittLinie.scale.z = Math.max(.001, s);
          if (!st.staub && t > tVorher) { st.staub = true; staub(new T.Vector3(BOCK.x, BOCKH + .08, BOCK.z)); }
        }
        if (c < .5) st.staub = false;
      }
    }
    schnittLinie.visible = schnittAktiv;
    let gesetzt = 0;
    for (const p of teile) {
      const x = teilLage(p, t);
      if (x >= 1) gesetzt += p.hoehe / H;
      const [a, b] = p.schritt.zeit, f = clamp((t - a) / ((b - a) * .3));   // Federn stecken, bevor das Element ankommt
      if (p.feder) { p.feder.visible = f > 0; p.feder.scale.set(Math.max(.001, ease(f)), 1, 1); }
      if (p.vfeder) { p.vfeder.visible = f > 0; p.vfeder.scale.set(1, Math.max(.001, ease(f)), 1); }
    }
    leisteO.visible = t > zeitVon("leisteO")[0]; leisteO.scale.x = Math.max(.001, ease(anteil(t, zeitVon("leisteO"))));
    // Aufklappen eines ganzen Elements (2. Spalte, Mitte)
    const e = glatt(anteil(t, Z.auf)) * (1 - glatt(anteil(t, Z.zu)));
    const vorne = auf.g.userData.vorne;
    if (e > 0 && t >= auf.schritt.zeit[1]) {
      auf.g.position.set(auf.ziel.x, auf.ziel.y + e * .12, auf.ziel.z + e * .78); auf.g.rotation.set(0, e * .32, 0);
      vorne.position.set(e * .7, 0, KD / 2 + GK / 2 + e * .06); auf.g.userData.hinten.position.z = -(KD / 2 + GK / 2) - e * .05;
    } else { vorne.position.set(0, 0, KD / 2 + GK / 2); auf.g.userData.hinten.position.z = -(KD / 2 + GK / 2); }
    const f = anteil(t, Z.farbe); M.farbe.opacity = f; anstrich.visible = anstrichH.visible = f > 0;
    const d = ease(anteil(t, Z.deko)); deko.visible = d > 0; deko.position.y = (1 - d) * .25; deko.traverse((m) => { if (m.material) m.material.opacity = d; });
    // Zähler: verbaute Elemente (Hälften zählen halb) und gespeichertes CO₂
    zEl.textContent = zahl(gesetzt, gesetzt % 1 ? 1 : 0); zCo2.textContent = Math.round(gesetzt * CO2_BLOCK);
    // Kamera
    const kU = kurvenU(t); zielP.copy(kurveP.getPoint(kU)); zielZ.copy(kurveZ.getPoint(kU));
    if (mobil) { zielZ.y += .3; zielP.sub(zielZ).multiplyScalar(1.18).add(zielZ); }
    camera.position.copy(zielP); camera.lookAt(zielZ);
    scene.updateMatrixWorld(); camera.updateMatrixWorld();
    const sichtbar = e > .6, rahmen = canvas.getBoundingClientRect();
    const punkt = (lx, ly, lz, el) => { tmp.set(lx, ly, lz); auf.g.localToWorld(tmp); tmp.project(camera);
      el.style.left = `${rahmen.left + (tmp.x + 1) / 2 * rahmen.width}px`; el.style.top = `${rahmen.top + (1 - tmp.y) / 2 * rahmen.height - 8}px`; el.style.opacity = sichtbar && tmp.z < 1 ? 1 : 0; };
    punkt(e * .7, .22, KD / 2 + GK + e * .06, marken.gips); punkt(-.08, .05, KD / 2, marken.kern); punkt(.12, auf.hoehe / 2, 0, marken.kanal);
    tVorher = t;
  }

  // Rechner-Ansicht: Kamera rahmt die Wand, Aufbau-Animation, Maßangaben
  const massL = document.getElementById("mass-l"), massH = document.getElementById("mass-h");
  const kamRZ = new T.Vector3(), kamRP = new T.Vector3();
  function rechnerSzene(jetzt) {
    if (!rechnerWand) return false;
    const { L, H: gh, z } = rechnerWand.userData;
    let laeuft = false;
    if (aufbau) {
      const k = clamp((jetzt - aufbau.t0) / aufbau.dauer);
      rechnerWand.children.forEach((g) => { if (g.userData.i === undefined) return;
        const s = clamp(k * aufbau.n * 1.0 - g.userData.i * .85); g.visible = s > 0; const e = ease(Math.min(1, s * 2.2));
        g.position.y = g.userData.y + (1 - e) * .5; g.scale.setScalar(.85 + .15 * e);
      });
      laeuft = k < 1; if (!laeuft) { aufbau = null; document.getElementById("k-zeit-box").classList.remove("bauen"); }
    }
    // Abstand so, dass die Wand in den freien Bildbereich passt (Desktop: rechts neben dem Rechner, Handy: ganze Breite)
    const breite = L + .7, hoehe = gh + .6;
    const tanH = Math.tan(camera.fov * Math.PI / 360), frei = mobil ? .44 : .27;
    const dist = Math.max(hoehe / (1.55 * tanH), breite * ansicht.h / (4 * tanH * frei * ansicht.w)) * 1.05;
    kamRZ.set(L / 2, gh / 2 + .05, 0);
    kamRP.set(kamRZ.x + dist * .3, kamRZ.y + dist * .18 + .3, dist);
    camera.position.lerp(kamRP, still ? 1 : .08); zielZ.lerp(kamRZ, still ? 1 : .08); camera.lookAt(zielZ);
    if (camera.position.distanceTo(kamRP) > .01) laeuft = true;
    scene.updateMatrixWorld(); camera.updateMatrixWorld();
    const rahmen = canvas.getBoundingClientRect();
    const setze = (el, v3, text) => { const v = v3.clone().project(camera); el.hidden = v.z > 1; el.style.left = `${rahmen.left + (v.x + 1) / 2 * rahmen.width}px`; el.style.top = `${rahmen.top + (1 - v.y) / 2 * rahmen.height}px`; if (text) el.textContent = text; };
    setze(massL, new T.Vector3(L / 2, .02, z + .12), `${zahl(L, 2)} m`);
    setze(massH, new T.Vector3(L + .25, gh / 2, rechnerWand.userData.z - .2), `${zahl(gh - 2 * LH, 2)} m`);
    return laeuft;
  }

  // ---------- Partikel
  function partikelSchritt(dt) {
    for (let i = partikel.length - 1; i >= 0; i--) {
      const m = partikel[i], u = m.userData; u.t += dt;
      m.position.addScaledVector(u.v, dt); u.v.y -= dt * .25; m.rotation.x += u.r.x * dt; m.rotation.y += u.r.y * dt;
      m.material.opacity = Math.max(0, 1 - u.t / u.d);
      if (u.t > u.d) { scene.remove(m); m.geometry.dispose(); m.material.dispose(); partikel.splice(i, 1); }
    }
    return partikel.length > 0;
  }

  // ---------- Scroll -> t
  const abschnitte = [...sec.querySelectorAll("[data-t]")];
  let marken_ = [];
  function vermessen() {
    const linie_ = innerWidth < 900 ? innerHeight * .73 : innerHeight / 2;
    marken_ = abschnitte.map((s) => { const p = s.querySelector(".panel"); const top = p.getBoundingClientRect().top + scrollY;
      return { y: top + p.offsetHeight / 2 - linie_, t: +s.dataset.t, seite: s.dataset.seite }; });
  }
  function zielT() { const y = scrollY; if (!marken_.length || y <= marken_[0].y) return 0;
    for (let i = 1; i < marken_.length; i++) if (y <= marken_[i].y) { const a = marken_[i - 1], b = marken_[i]; return a.t + (b.t - a.t) * (y - a.y) / (b.y - a.y); } return 1; }
  function zielSeite() { if (modus === "rechner") return 1; const y = scrollY + innerHeight / 2; let best = marken_[0], d = 1e9;
    for (const m of marken_) { const dd = Math.abs(m.y + innerHeight / 2 - y); if (dd < d) { d = dd; best = m; } }
    return !best ? .5 : best.seite === "links" ? 0 : best.seite === "rechts" ? 1 : .5; }

  const ansicht = { w: 1, h: 1, voll: 1, vollH: 1, x: 0 };
  let mobil = false, modus = "start", schmutzig = true, tJetzt = 0, seiteJetzt = 0, letzteZeit = performance.now();
  function groesse() {
    mobil = innerWidth < 900;
    const r = canvas.getBoundingClientRect(), w = Math.round(r.width), h = Math.round(r.height);
    renderer.setSize(w, h, false); ansicht.w = w; ansicht.h = h; ansicht.voll = mobil ? w : w * 1.45; ansicht.vollH = h;
    camera.aspect = ansicht.voll / ansicht.vollH; camera.fov = mobil ? 40 : 36; vermessen(); schmutzig = true;
  }
  function modusSetzen(m) {
    modus = m; const r = m === "rechner";
    raum.visible = startGruppe.visible = !r; rechnerGruppe.visible = r;
    sonne.visible = !r; studio.visible = r;
    scene.fog.near = r ? 20 : 14; scene.fog.far = r ? 60 : 34;
    for (const el of [massL, massH]) el.hidden = !r;
    for (const el of Object.values(marken)) el.style.opacity = 0;
    document.getElementById("zaehler").hidden = r;
    if (r) { seiteJetzt = 0; window.__rechnen(); } else { requestAnimationFrame(() => { vermessen(); schmutzig = true; }); }
    schmutzig = true;
  }
  window.__wand = { modus: modusSetzen, rechnerWand: (L, H_, typ) => window.__wandBau(L, H_, typ) };

  let aktiv = true;               // nur rendern, solange der Abschnitt sichtbar ist
  new IntersectionObserver(([e]) => { aktiv = e.isIntersecting; if (aktiv) { vermessen(); schmutzig = true; } }, { rootMargin: "200px 0px" }).observe(sec);
  if (window.ResizeObserver) new ResizeObserver(() => { vermessen(); schmutzig = true; }).observe(sec.querySelector(".s3d__inhalt"));

  function bild(jetzt) {
    const dt = Math.min(.05, (jetzt - letzteZeit) / 1000); letzteZeit = jetzt;
    if (!aktiv) { requestAnimationFrame(bild); return; }
    let rendern = schmutzig;
    const sZiel = modus === "rechner" ? 0 : zielSeite(), ds = sZiel - seiteJetzt;
    if (Math.abs(ds) > 1e-4) { seiteJetzt += ds * (still ? 1 : .085); rendern = true; }
    // Bildausschnitt: Startseite verschiebt die Bühne je nach Panel-Seite; Rechner: Bühne rechts neben dem Rechner (Mitte bei 70 %)
    ansicht.voll = mobil ? ansicht.w : ansicht.w * (modus === "rechner" ? 1.4 : 1.45);
    ansicht.x = mobil ? 0 : (ansicht.voll - ansicht.w) * seiteJetzt;
    camera.aspect = ansicht.voll / ansicht.vollH;
    camera.setViewOffset(ansicht.voll, ansicht.vollH, ansicht.x, 0, ansicht.w, ansicht.h); camera.updateProjectionMatrix();
    if (modus === "start") {
      const tZiel = zielT(), dT = tZiel - tJetzt;
      if (Math.abs(dT) > 1e-5 || rendern) { tJetzt += dT * (still ? 1 : .085); if (Math.abs(dT) < 1e-5) tJetzt = tZiel; startSzene(tJetzt); rendern = true; }
    } else if (rechnerSzene(jetzt)) rendern = true;
    if (partikelSchritt(dt)) rendern = true;
    if (rendern) { renderer.render(scene, camera); schmutzig = false; }
    requestAnimationFrame(bild);
  }
  addEventListener("resize", groesse);
  addEventListener("load", () => { vermessen(); schmutzig = true; });
  groesse();
  modusSetzen(sec.dataset.modus || "start"); vermessen();
  requestAnimationFrame(bild);
}

})();
